import type { ReactNode } from 'react'

type StrokeIconProps = { size: number; stroke: number; children: ReactNode }

// The design's inline line icons, drawn with the current text color.
const StrokeIcon = ({ size, stroke, children }: StrokeIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={stroke}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    focusable='false'>
    {children}
  </svg>
)

export const LauncherIcon = () => (
  <StrokeIcon size={20} stroke={2}>
    <path d='M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z' />
  </StrokeIcon>
)

export const SendIcon = () => (
  <StrokeIcon size={20} stroke={2}>
    <path d='M22 2 11 13' />
    <path d='M22 2 15 22l-4-9-9-4z' />
  </StrokeIcon>
)

export const ChevronDownIcon = () => (
  <StrokeIcon size={22} stroke={2.2}>
    <path d='m6 9 6 6 6-6' />
  </StrokeIcon>
)

export const CheckIcon = () => (
  <StrokeIcon size={16} stroke={2.4}>
    <path d='M20 6 9 17l-5-5' />
  </StrokeIcon>
)

export const PlusIcon = () => (
  <StrokeIcon size={18} stroke={2.4}>
    <path d='M12 5v14M5 12h14' />
  </StrokeIcon>
)

export const ChevronUpIcon = () => (
  <StrokeIcon size={14} stroke={2.4}>
    <path d='m6 15 6-6 6 6' />
  </StrokeIcon>
)

export const AlertCircleIcon = () => (
  <StrokeIcon size={16} stroke={2.2}>
    <circle cx='12' cy='12' r='9' />
    <path d='M12 8v5' />
    <path d='M12 16.5h.01' />
  </StrokeIcon>
)

export const CloseIcon = () => (
  <StrokeIcon size={18} stroke={2.2}>
    <path d='M18 6 6 18' />
    <path d='m6 6 12 12' />
  </StrokeIcon>
)
